'use strict';

/**
 * Base class for a Model
 *
 * @category   Model
 * @module     base
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Backbone = require('backbone');

var Model = Backbone.Model.extend({
    customAttributes: {},

    cacheCustomAttributes: true,

    /**
     * Array of attributes that should be treated like local attributes and should not be patched to server
     */
    localAttributes: null,

    initialize: function(attributes, options) {
        this.listenTo(this, 'change', this.modelChanged.bind(this));
        this.clearUpdatedAttributes();
        this.customAttributesCache = {};
    },

    /**
     * Is triggered when any attribute has changed
     */
    modelChanged: function() {
        var changedKeys = _.difference(_.keys(this.changed), this.localAttributes);
        if (changedKeys.length) {
            var changedAttributes = _.omit(this.changed, this.localAttributes);
            this.updatedAttributes = _.extend(this.updatedAttributes || {}, changedAttributes);
            this.updatedAttributes[this.idAttribute] = this.id;
            this.trigger('change:synced', this, changedAttributes);
        }

        //clear custom attributes cache
        this.customAttributesCache = {};
    },

    /**
     * Clears the updated attributes
     */
    clearUpdatedAttributes: function() {
        this.updatedAttributes = {};
    },

    toJSON: function(options) {
        options = _.extend({}, options);
        if (options.syncedOnly) {
            return _.omit(this.attributes, this.localAttributes);
        } else {
            return Backbone.Model.prototype.toJSON.apply(this, arguments);
        }
    },

    urlRoot: function() {
        var endpoint = _.result(this, 'api');

        return App.getApiUrl(endpoint);
    },

    get: function (attributeName, ignoreCustomAttributes) {
        if (_.isFunction(this.customAttributes[attributeName]) && ignoreCustomAttributes !== true) {
            if (this.cacheCustomAttributes) {
                if (!_.has(this.customAttributesCache, attributeName)) {
                    this.customAttributesCache[attributeName] = this.customAttributes[attributeName].bind(this)();
                }

                return this.customAttributesCache[attributeName];
            }

            return this.customAttributes[attributeName].bind(this)();
        }

        return Backbone.Model.prototype.get.call(this, attributeName);
    },

    getDeep: function(attributeName, ignoreCustomAttributes) {
        var path = attributeName.split('.');

        attributeName = path.shift();

        var attributeValue = this.get(attributeName, ignoreCustomAttributes);

        var propertyName;
        while (path.length) {
            propertyName = path.shift();

            if (propertyName && _.has(attributeValue, propertyName)) {
                attributeValue = attributeValue[propertyName];
            }
        }

        return attributeValue;
    },

    save: function (key, val, options) {
        // Handle both `"key", value` and `{key: value}` -style arguments.
        var attrs;
        if (key == null || typeof key === 'object') {
            attrs = key;
            options = val;
        } else {
            (attrs = {})[key] = val;
        }

        options = _.extend({syncedOnly: true}, options);

        var success = options.success;
        options.success = function(model, resp, options) {
            model.clearUpdatedAttributes();
            if (success) {
                success(model, resp, options);
            }
        };

        return Backbone.Model.prototype.save.call(this, attrs, options);
    },
});

module.exports = Model;